let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Bsq4")).then(() => parcelRequire('fMkOJ'));